import { render, staticRenderFns } from "./ReferralCard.vue?vue&type=template&id=d6bb1068"
import script from "./ReferralCard.vue?vue&type=script&lang=js"
export * from "./ReferralCard.vue?vue&type=script&lang=js"
import style0 from "./ReferralCard.vue?vue&type=style&index=0&id=d6bb1068&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports